export const refineryVolume = [
  {
    id: 1,
    name: "IRPC",
    volume: 100000,
  },
  {
    id: 2,
    name: "SPRC",
    volume: 200000,
  },
  {
    id: 3,
    name: "TOP",
    volume: 300000,
  },
  {
    id: 4,
    name: "PTTGC",
    volume: 400000,
  },
  {
    id: 5,
    name: "ESSO",
    volume: 500000,
  },
  {
    id: 6,
    name: "BCP",
    volume: 600000,
  },
];
